module.exports = __webpack_public_path__ + "img/circle-table-4.e551b7b0.png";